// extracted by mini-css-extract-plugin
module.exports = {"SocialProof":"_1vGYUHtm","TopQuoteContainer":"_3i2-gYUL","BottomQuoteContainer":"PFW3iTdd","QuoteContainer":"CXU7xi72","QuoteOne":"_1FNVmDVp","QuoteTwo":"_2DRF4QBf","QuoteThree":"_1UIvlHop","Person":"_2Vh72g-y","Avatar":"_1hTU9biD","Info":"zXhDn82f","Name":"_2iwLC8JB","Role":"Z5ZtQ4fY"};
    if(module.hot) {
      // 1754514933031
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  